export default {
    title: 'Congratulations! Your feedback cycle has been scheduled!',
    goToDashboard: 'Go to dashboard',
};
